import React from "react";
//#region types
import { ResultItemListWrapperProps } from "models/propTypes/resultItemPropTypes";
import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ResultItem from "components/common/lists/resultItem";
import { Grid, Skeleton } from "@mui/material";
import ResultItemList from "./resultItemList";
import StyledButton from "../buttons/styledButton";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ResultItemListWrapper: React.FC<ResultItemListWrapperProps> = (props) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [showLoadMore, setShowLoadMore] = React.useState<boolean>(false);
  const [filter, setFilter] = React.useState<WintUtilsWebApi.Filter>({
    page: 0,
    numPerPage: props.pageCount ?? 10,
    orderByDescending: true,
    thenByDescending: true,
    isAutoPaginating: true,
  });

  const onLoadMoreClick = async () => {
    setLoading(true);
    const updatedFilter = { ...filter, page: filter.page + 1 };
    setFilter({ ...updatedFilter });
    if (props.onLoadMoreClick) {
      const count = await props.onLoadMoreClick(updatedFilter);
      if (count < (filter.numPerPage ?? 0)) setShowLoadMore(false);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    setShowLoadMore(props.items.length >= (filter.numPerPage ?? 0));
  }, [props.items]);

  return (
    <>
      <ResultItemList {...props}></ResultItemList>
      {props.loadMore && showLoadMore && (
        <ResultItem
          key={"load-more"}
          item={{ id: 0, value: "loadmore" }}
          onClickHandler={() => {}}
          getItemTemplate={(data: any) => (
            <Grid container justifyContent={"center"} className={cssExports.loadMore}>
              {loading ? (
                <Grid item container spacing={2} direction="row">
                  <Grid item key={"1"} xs={4}>
                    <Skeleton width="100%" height="56px" />
                    <Skeleton width="100%" height="56px" />
                  </Grid>
                  <Grid item key={"2"} xs={4}>
                    <Skeleton width="100%" height="56px" />
                    <Skeleton width="100%" height="56px" />
                  </Grid>
                  <Grid item key={"3"} xs={4}>
                    <Skeleton width="100%" height="56px" />
                    <Skeleton width="100%" height="56px" />
                  </Grid>
                </Grid>
              ) : (
                <StyledButton
                  onClick={onLoadMoreClick}
                  secondary
                  size="xs"
                >{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.LoadMore)}`}</StyledButton>
              )}
            </Grid>
          )}
          isSelected={false}
          hideIcon={true}
        />
      )}
    </>
  );
};

export default ResultItemListWrapper;
